<template>
	<div :class="['form-group', inputClass, {'has-error': error.length > 0}]">
		<span v-if="required">* </span><label>{{ label }}:</label>
		<i
			v-if="tooltip != ''"
			class="fa fa-fw fa-info-circle"
			v-tooltip="tooltip"
		></i>
		<div class="input-wrapper">
			<template v-if="inputType === 'text'">
				<input
					type="text"
					v-model="conteudoInput"
					:required="required"
					class="form-control"
					@input="setValue(conteudoInput)"
				/>
			</template>
			<template v-else-if="inputType === 'textarea'">
				<textarea
					rows="4"
					type="text"
					v-model="conteudoInput"
					:required="required"
					class="form-control"
					@input="setValue(conteudoInput)"
				>
				</textarea>
			</template>
			<template v-else-if="inputType === 'select'">
				<select
					v-model="opcaoSelect"
					:required="required"
					class="form-control"
					@change="setValue(opcaoSelect)"
				>
					<option>
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="option in options" :value="option.key">
						{{ option.value }}
					</option>
				</select>
			</template>
			<template v-else-if="inputType === 'datetime'">
				<flDateTime
					@v-model="(val) => (dateTime = val)"
					:required="required"
					:lang="_getLangDp"
					:format="_formatDate"
					@change="setValue(value)"
				></flDateTime>
			</template>
			<template v-else-if="inputType === 'SimNao'">
				<flSimNao v-model="simNao" />
			</template>
			<template v-else-if="inputType === 'add'">
				<div class="input-group">
					<select class="form-control input-sm" v-model="opcaoSelect">
						<option>
							{{ _traducao('global', 'escolha').toUpperCase() }}
						</option>
						<option
							v-for="orgaoOption in options"
							:value="orgaoOption.key"
							:key="orgaoOption.value"
						>
							{{ orgaoOption.value }}
						</option>
					</select>
					<span class="input-group-btn">
						<button
							class="btn btn-sm btn-info"
							:disabled="opcaoSelect == ''"
							@click="
								clickAdd(opcaoSelect)
								setValue(listaInterna)
							"
							type="button"
						>
							ADD
							<i class="fa fa-arrow-right fa-fw"></i>
						</button>
					</span>
				</div>
				<div>
					<span
						v-for="(itemLista, indexLista) in listaInterna"
						:key="indexLista"
						style="margin-top: 3px"
					>
						<span
							v-if="!itemLista.excluir"
							title="Clique para remover"
							class="label-click"
							@click="
								clickExcluir(itemLista, indexLista)
								setValue(listaInterna)
							"
						>
							{{ itemLista.value }}
							<i class="fa fa-times no-print"></i>
						</span>
					</span>
				</div>
			</template>
		</div>
		<p v-for="erro in error" class="help-block">
			{{ erro }}
		</p>
	</div>
</template>
<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},
		value: {
			required: true
		},
		required: {
			type: Boolean,
			default: false
		},
		error: {
			type: [Array, String],
			default: () => []
		},
		inputClass: {
			type: String,
			default: ''
		},
		inputType: {
			type: String,
			default: '',
			required: true
		},
		options: {
			type: Array,
			default: () => []
		},
		tooltip: {
			type: String,
			default: ''
		}
	},
	watch: {
		dateTime: function (newData) {
			this.setValue(newData)
		},
		simNao: function (newSimNao) {
			this.setValue(newSimNao)
		}
	},
	data() {
		return {
			opcaoSelect: this.value,
			dateTime: '',
			simNao: false,
			listaInterna: [],
			conteudoInput: this.value
		}
	},
	methods: {
		/*	A forma abaixo é como a lista para o flSelect deve ser enviada com Chave e Valor.
        computed: {
		aeronaveOptions() {
			return this.lista_aeronave.map((aeronave) => ({
				key: aeronave.id,
				value: aeronave.prefixo
			}))
		    }
	    },*/
		clickAdd(property) {
			let itemLista = this.options.find((item) => item.key == property)
			const objetoExists = this.listaInterna.some(
				(obj) => obj.key === itemLista.key
			)
			if (!objetoExists) {
				itemLista = {
					...itemLista,
					excluir: false
				}
				this.listaInterna.push(itemLista)
			} else {
				const index = this.listaInterna.findIndex(
					(item) => item.id === itemLista.id
				)

				if (index !== -1) {
					this.listaInterna[index].excluir = false
				}
			}
		},
		clickExcluir(item, index) {
			if (!Number(item.key)) {
				this.listaInterna.splice(index, 1)
			} else {
				item.excluir = true
				const itemIndex = this.listaInterna.findIndex((it) => it.id == item.id)
				this.$set(this.listaInterna, itemIndex, item)
			}
			this.$forceUpdate()
		},
		setValue(valor) {
			this.$emit('input', valor)
			this.$emit('change', valor)
		}

		/* Para utilizar o global Mixin _validaForm as mensagens de erro devem ser passadas na forma abaixo.
        formErrorMsg: {},
			conditionMessages: [
				{
					property: 'username',
					condition: (value) => value == '',
					message: 'Obrigatório'
				},
				{
					property: 'username',
					condition: (value) => value === 'sim',
					message: 'Não utilizar palavra sim'
	    },*/
	}
}
</script>